 
<div class="col-md-12 main-heading">
    <div class="d-flex">
        <a routerLink="/index">
            <div class="icon-heading"><img src="assets/images/pages-icon/backbtn.png" class="img-responsive"> </div>
        </a>
        <div class="caption-heading">Live Events</div>
    </div>
</div>
<div class="col-md-12 pagecustom">
    <div class="page-wrapper">
        <div class="row main-container boxscroll">
            <div class="block-section full-table">
                <div class="heading-m">
                    <div class="caption">
                        <img src="assets/images/pages-icon/live_events.png">Current Activity <Span class="green" style="padding: 3px;" *ngIf="connectionEstablished; else elseBlock">Connected</Span>
                        <ng-template #elseBlock><span class="red" style="padding: 3px;">Disconnected</span></ng-template>
                    </div>
                </div>
                <div class="list-sidebar" style="overflow-y: auto;">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>Event Date</th>
                                <th>Device Name</th>
                                <th>Event Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let eve of eventsList">
                                <td nowrap="yes">{{eve.eventDate}}</td>
                                <td nowrap="yes">{{eve.deviceName}}</td>
                                <td>{{eve.eventDetail}}</td>
                            </tr>
                             
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>